import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const EmptyChatsIcon = (props: IconProps) => (
  <Icon width="231px" height="240px" viewBox="0 0 231 240" {...props}>
    <circle cx="115.41" cy="120.357" r="115.357" fill="#CCE4FF" opacity=".38" />
    <path
      fill="#CCE4FF"
      stroke="#CCE4FF"
      d="m32.6006 152.875.0016.001.0053.006.0023.003c.2887.307.6743.474 1.076.474.2791 0 .5545-.082.7986-.235h.0005l24.189-15.212c2.1159-1.048 4.5766-1.139 6.7544-.251 10.7457 4.38 22.9647 6.694 35.3397 6.694 19.339 0 37.549-5.488 51.265-15.479 6.682-4.868 11.942-10.547 15.621-16.882 3.818-6.573 5.758-13.5666 5.758-20.7808 0-7.2143-1.942-14.2083-5.758-20.7804l-.432.2511.432-.2511c-3.681-6.3374-8.939-12.0162-15.621-16.8821-13.716-9.991-31.924-15.4792-51.265-15.4792s-37.5493 5.4882-51.2654 15.4792c-6.6817 4.8675-11.9416 10.5445-15.6209 16.882-3.818 6.5722-5.7576 13.5662-5.7576 20.7805 0 6.0354 1.3716 11.9558 4.0704 17.5948h.0001c2.6071 5.441 6.3934 10.509 11.2486 15.063 2.6216 2.46 3.3857 6.268 1.9225 9.503L32.4912 150.98c-.0002 0-.0005.001-.0007.001-.4316.588-.3836 1.361.1101 1.894Zm133.5874-41.733.433.251-.433-.251c-3.551 6.117-8.646 11.624-15.152 16.362l.294.405-.294-.404c-13.404 9.763-31.256 15.154-50.27 15.154-12.0443 0-23.9276-2.229-34.3884-6.443v-.001l-.3109-.127c-1.1967-.489-2.4647-.731-3.7321-.731-1.5274 0-3.0548.352-4.455 1.054l-.0152.008-.0146.008-.0289.018-.0062.003-.0061.004-23.3192 14.665 12.3146-16.841.0317-.043.0218-.049.0101-.023c.0006-.002.0012-.003.0018-.004 1.8157-3.917.9028-8.549-2.2687-11.524l-.3421.365.3421-.365c-4.7115-4.419-8.3704-9.319-10.8794-14.559-2.5925-5.412-3.9042-11.0846-3.9042-16.8608 0-6.905 1.857-13.6075 5.5286-19.9302 3.5532-6.1172 8.6465-11.6242 15.1526-16.3628C63.902 45.158 81.7536 39.7657 100.768 39.7657c19.014 0 36.864 5.3923 50.268 15.1561l.294-.4041-.294.4042c6.506 4.7386 11.599 10.2456 15.152 16.3627 3.67 6.3211 5.527 13.0252 5.527 19.9286 0 6.9034-1.855 13.6078-5.527 19.9288Z"
    />
    <path
      fill="#CCE4FF"
      d="M156.678 107.369c1.803-4.061 2.795-8.4549 2.901-12.9152.046-1.912 1.568-3.4574 3.476-3.5102 2.267-.0631 4.017 1.9734 3.625 4.2095-.831 4.7366-2.668 9.2769-5.419 13.2799-2.775 4.038-6.271 2.738-4.583-1.064ZM163.382 87.7114c-2.349.5936-4.736-.8733-5.243-3.2476-.38-1.7722-.908-3.5375-1.592-5.279-3.387-8.6238-9.942-15.0541-17.795-18.4842-6.61-2.8859.269-6.6435 8.136-3.2066 7.856 3.4301 14.409 9.8604 17.795 18.4842.889 2.2617 1.514 4.5609 1.892 6.8652.362 2.2055-1.029 4.3222-3.193 4.868Z"
    />
    <path
      fill="#CCE4FF"
      stroke="#CCE4FF"
      d="m194.894 193.675.001-.001c.404-.436.444-1.073.09-1.555l-.091 1.556Zm0 0-.006.007-.002.002c-.236.25-.552.387-.883.387-.231 0-.457-.067-.656-.192l-17.682-11.12c-1.512-.746-3.268-.81-4.823-.177-7.875 3.211-16.827 4.905-25.892 4.905-14.166 0-27.511-4.02-37.566-11.344-4.899-3.569-8.7592-7.735-11.4601-12.386-2.8031-4.826-4.2283-9.963-4.2283-15.263 0-5.301 1.4265-10.438 4.2283-15.263l.4323.251-.4323-.251c2.7021-4.653 6.5601-8.819 11.4601-12.386 10.055-7.325 23.399-11.345 37.566-11.345 14.167 0 27.51 4.02 37.566 11.345 4.899 3.569 8.759 7.733 11.46 12.386 2.803 4.825 4.228 9.962 4.228 15.263 0 4.434-1.008 8.783-2.989 12.924h-.001c-1.914 3.995-4.693 7.714-8.254 11.054-1.872 1.757-2.419 4.473-1.381 6.783l9.406 12.863-.091 1.557Zm-2.002-1.865-16.457-10.35-.006-.004-.006-.003-.021-.013-.015-.008-.015-.008c-1.043-.523-2.181-.785-3.318-.785-.944 0-1.889.181-2.78.545l-.305.124c-7.614 3.055-16.257 4.67-25.018 4.67-13.88 0-26.905-3.935-36.68-11.055l-.294.404.294-.404c-4.744-3.456-8.4565-7.469-11.0429-11.924-2.6736-4.603-4.0234-9.482-4.0234-14.505 0-5.023 1.351-9.902 4.0234-14.505 2.5876-4.455 6.2989-8.469 11.0429-11.924l-.294-.405.294.405c9.775-7.121 22.799-11.057 36.679-11.057 13.88 0 26.905 3.936 36.68 11.055m11.262 69.747-11.262-69.747m11.262 69.747-8.59-11.748-.032-.043-.022-.049-.006-.015c-.001-.001-.001-.003-.002-.004-1.352-2.917-.671-6.366 1.69-8.58 3.434-3.221 6.099-6.791 7.926-10.606 1.887-3.94 2.841-8.068 2.841-12.271 0-5.025-1.351-9.902-4.024-14.507m.219 57.823-.219-57.823m-11.043-11.924c4.744 3.456 8.455 7.469 11.043 11.924m-11.043-11.924 11.043 11.924"
    />
    <path
      fill="#CCE4FF"
      d="M185.833 160.307c1.319-2.969 2.045-6.182 2.122-9.444.033-1.398 1.146-2.528 2.542-2.567 1.657-.046 2.937 1.444 2.651 3.079-.608 3.463-1.951 6.783-3.963 9.711-2.03 2.952-4.585 2.001-3.352-.779ZM190.736 145.933c-1.718.434-3.463-.639-3.834-2.375-.278-1.296-.664-2.587-1.165-3.86-2.476-6.306-7.269-11.008-13.012-13.516-4.833-2.111.197-4.858 5.95-2.345 5.744 2.508 10.536 7.21 13.012 13.516.65 1.654 1.107 3.335 1.383 5.02.266 1.613-.752 3.161-2.334 3.56Z"
    />
    <rect
      width="36.4286"
      height="12.8571"
      x="169.338"
      y="26.4285"
      fill="#CCE4FF"
      rx="6.42857"
    />
    <circle cx="176.481" cy="32.857" r="2.14286" fill="#99CAFF" />
    <circle cx="183.624" cy="32.857" r="2.14286" fill="#99CAFF" />
    <ellipse
      cx="190.767"
      cy="32.857"
      fill="#99CAFF"
      rx="2.14285"
      ry="2.14286"
    />
    <circle cx="197.91" cy="32.857" r="2.14286" fill="#99CAFF" />
    <rect
      width="36.4286"
      height="12.8571"
      x="12.9098"
      y="183.571"
      fill="#CCE4FF"
      rx="6.42857"
    />
    <ellipse cx="20.0527" cy="190" fill="#99CAFF" rx="2.14286" ry="2.14285" />
    <ellipse cx="27.1956" cy="190" fill="#99CAFF" rx="2.14286" ry="2.14285" />
    <ellipse cx="34.3384" cy="190" fill="#99CAFF" rx="2.14286" ry="2.14285" />
    <ellipse cx="41.4813" cy="190" fill="#99CAFF" rx="2.14286" ry="2.14285" />
    <mask
      id="a"
      width="39"
      height="38"
      x="189"
      y="49"
      maskUnits="userSpaceOnUse"
    >
      <circle cx="208.517" cy="67.7502" r="18.5307" fill="#B94C24" />
    </mask>
    <g mask="url(#a)">
      <rect
        width="73.3815"
        height="70.046"
        x="184.057"
        y="42.1777"
        fill="#A2E6F5"
      />
      <path
        fill="#1D9AD2"
        d="M206.965 83.9955c-4.375.2712-10.028-1.1729-12.85 7.1016-2.162 14.9219-5.863 72.4969-5.863 72.4969l41.817.311s-1.718-50.687-6.951-72.8174c-1.442-6.0977-4.701-4.2848-6.39-5.5933-2.805-1.1824-6.038-1.732-9.758-1.5012l-.005.0024Z"
      />
      <path
        fill="#1D9AD2"
        d="M200.982 96.7761s-11.469-5.4887-7.685-13.6657c3.784-8.1771 32.985-4.9296 32.805 2.2935-.181 7.2206-14.239 12.3381-14.239 12.3381l-10.879-.9659h-.002Z"
      />
      <path
        fill="#5B5B5B"
        d="M199.823 70.5582s-1.582-5.3244-.221-8.8765c1.715-4.4679 9.879-9.4356 12.556-8.1913 2.679 1.2443-1.276 4.0945-.057 4.449 1.219.3545 1.957-2.4814 2.772-1.9557 3.292 2.1246 1.162 13.3112 1.162 13.3112l-11.476-3.4426-4.736 4.7059Z"
      />
      <path
        fill="#F9C1AD"
        d="m212.533 85.4824-3.936 3.7495-3.938-3.7495.691-8.4958h6.492l.691 8.4958Z"
      />
      <path
        fill="#F9C1AD"
        d="M215.127 66.873c-.449-4.0254-3.986-6.2975-7.993-5.8502-4.005.4472-6.96 3.4449-6.511 7.468 0 0 .257 5.1699.285 5.4197.425 3.8256 5.639 8.1556 8.533 7.832 3.339-.3735 6.924-6.6258 6.601-9.5212-.029-.2498-.917-5.3507-.917-5.3507l.002.0024Z"
      />
      <path
        fill="#F9C1AD"
        d="M201.091 69.4498s-.993-.4949-1.603.5401c-.611 1.0373.266 4.5726 2.057 4.3728 1.791-.1999-.456-4.9129-.456-4.9129h.002ZM214.937 67.9032s.86-.7019 1.684.1736c.822.8779.746 4.518-1.047 4.7178-1.791.1999-.637-4.8914-.637-4.8914Z"
      />
      <g clipPath="url(#b)">
        <path
          fill="#CEA23E"
          d="m225.152 88.4955-25.113 4.163 41.245 21.9955-10.561-23.1874c-.974-2.1374-3.256-3.3549-5.571-2.9713v.0002Z"
        />
      </g>
    </g>
    <mask
      id="c"
      width="41"
      height="41"
      x="60"
      y="177"
      maskUnits="userSpaceOnUse"
    >
      <circle cx="80.4098" cy="197.5" r="20.3571" fill="#B94C24" />
    </mask>
    <g mask="url(#c)">
      <rect
        width="80.6143"
        height="76.95"
        x="53.5384"
        y="169.407"
        fill="#F3F6D3"
      />
      <path
        fill="#fff"
        d="M73.6951 212.163s-6.4823 4.42-8.3512 23.44c-1.3102 13.323-2.4412 18.005-2.4412 18.005l3.8204.055s7.4685-18.66 8.1443-26.943c.3172-3.91-1.1723-14.55-1.1723-14.55v-.007ZM87.6458 211.99s7.5236 2.938 9.1718 23.075c1.0896 13.337 2.2136 18.543 2.2136 18.543l-3.8204.055s-7.4684-18.66-8.1442-26.942c-.3173-3.911.5861-14.731.5861-14.731h-.0069Z"
      />
      <path
        fill="#fff"
        d="M78.6947 210.57c-2.4412.152-5.1307.579-5.8823 3.131-.5035 3.475 1.1585 14.585-.9448 25.95-2.9584 15.999-2.324 33.335-2.324 33.335l23.3294.173s.2966-17.503-2.0964-33.336c-1.6205-10.716-.2758-21.295-1.786-26.129-.7931-2.545-4.6066-2.793-5.9031-3.124-1.5654-.655-2.3171-.131-4.3928 0Z"
      />
      <path
        fill="#323232"
        d="M95.3419 195.598c0 8.096-6.5651 14.662-14.6611 14.662s-14.6611-6.566-14.6611-14.662 6.5651-14.661 14.6611-14.661 14.6611 6.565 14.6611 14.661Z"
      />
      <path
        fill="#323232"
        d="M76.2466 201.729s-.5517-3.048.4276-4.931c1.2275-2.365 4.8893-3.668 7.7098-1.151 1.9654 1.751.931 6.379.931 6.379l-6.1513-2.614-2.9171 2.31v.007Z"
      />
      <path
        fill="#653D2E"
        d="M83.0875 210.57s-2.5791 1.365-4.3928 0l.3862-4.731h3.6205l.3861 4.731ZM77.019 201.198s-.5172-.338-.9241.2c-.4.538-.131 2.545.8689 2.545 1 0 .0483-2.745.0483-2.745h.0069ZM84.7909 201.198s.5172-.338.9241.2c.3999.538.1379 2.545-.869 2.545-1.0068 0-.0482-2.745-.0482-2.745h-.0069Z"
      />
      <path
        fill="#653D2E"
        d="M84.9564 200.639c0-2.255-1.8206-3.73-4.0687-3.73s-4.0687 1.475-4.0687 3.73c0 0-.1793 2.876-.1793 3.021 0 2.145 2.6274 4.862 4.248 4.862 1.8757 0 4.248-3.241 4.248-4.862 0-.138-.1793-3.021-.1793-3.021Z"
      />
      <path
        fill="#fff"
        d="M76.9293 205.198s.0552-.014.0828-.028l-.0965-.234s-.0345.014-.0483.014c-.4483.124-.9172-.145-1.0413-.6-.1242-.449.1448-.918.5999-1.042l-.062-.241c-.5862.159-.9379.765-.7793 1.345.1586.586.7655.931 1.3516.779l-.0069.007ZM84.8047 205.198s-.0621-.021-.0966-.035c.0276.007.1035-.227.1035-.227.0207 0 .0413.014.0551.02.4483.125.9172-.144 1.0413-.599.1242-.449-.1448-.918-.5999-1.042l.062-.241c.5862.158.931.765.7793 1.345-.1586.586-.7655.931-1.3516.779h.0069Z"
      />
    </g>
    <defs>
      <clipPath id="b">
        <rect
          width="56.0927"
          height="56.1418"
          fill="#fff"
          transform="matrix(.882375 .470547 -.469399 .882986 205.928 71.6223)"
        />
      </clipPath>
    </defs>
  </Icon>
);

export default memo(EmptyChatsIcon);
